// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__UJ5Fn","layout-content":"layout_layout-content__g40g-","layout-outlet":"layout_layout-outlet__9A1DW"};